export const INDEX_ROW_ERRORS = {
  indexRow: 'IndexRow component was not found in the tree',
  item: 'IndexRow.Item component was not found in the tree',
};
